import React from "react";

import { Header } from "semantic-ui-react";

import ReimbursementLog from "../../../components/ReimbursementLog";
import PaymentLog from "../../../components/PaymentLog";

import PendingSubmitterTable from "../../../components/PendingSubmitterTable";

import { connect } from "react-redux";

import _ from "lodash";

import * as moment from "moment";

const PaymentsView = props => {
  return (
    <div>
      <Header dividing as="h3">
        <Header.Content>
          People who are awaiting payment
          <Header.Subheader>Click to see more.</Header.Subheader>
        </Header.Content>
      </Header>
      <PendingSubmitterTable pendingPeople={props.pendingPeople} />
      <Header dividing as="h3">
        <Header.Content>
          Recent payments
          <Header.Subheader>Up to 10 most recent payments.</Header.Subheader>
        </Header.Content>
      </Header>
      <PaymentLog payments={props.payments} />
      <Header dividing as="h3">
        <Header.Content>
          Activity log
          <Header.Subheader>Most recent activity first.</Header.Subheader>
        </Header.Content>
      </Header>
      <ReimbursementLog items={props.logItems} />
    </div>
  );
};

const mapStateToProps = state => {
  const approvedReimbursements = state.reimbursements.items.filter(
    r => r.status === "approved"
  );
  const groupedByUser = _.groupBy(
    approvedReimbursements,
    r => r.submitter.uuid
  );
  const pendingPeople = Object.keys(groupedByUser).map(pendingSubmitterUUID => {
    const pendingReimbursements = groupedByUser[pendingSubmitterUUID];
    return Object.assign({}, pendingReimbursements[0].submitter, {
      pendingReimbursements
    });
  });

  const logItems = _.flatMap(state.reimbursements.items, item => {
    return item.change_log.map(changeLogItem => {
      return Object.assign({}, changeLogItem, {
        reimbursement: item
      });
    });
  });

  return {
    logItems: _.sortBy(logItems, item => -+moment(item.timestamp)),
    pendingPeople,
    payments: state.reimbursements.payments.slice(0, 10)
  };
};

export default connect(mapStateToProps)(PaymentsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/reimbursements/PaymentsView.js